/**
 * Important: object keys in camelCase are derived from config file names given in kebab-case.
 */
const kebabToCamelCase = (s: string) => s.replace(/-./g, (x) => x[1].toUpperCase());

const allConfigs = import.meta.glob('./configurations/**/*.yaml', { eager: true });
const supportedLocales = ['cl', 'de', 'gb', 'in', 'us', 'pl', 'za'] as const;

/**
 * Helper function to load locale-specific configurations based on type.
 */
const loadConfigurations = (type: 'events' | 'slides') => {
  return supportedLocales.reduce(
    (configs, locale) => {
      const localeConfigFiles = Object.entries(allConfigs).filter(([path]) => path.includes(`/${locale}/${type}/`));

      configs[locale] = localeConfigFiles.reduce(
        (acc, [path, yamlModule]) => {
          if (type === 'slides') {
            const key = kebabToCamelCase(path.split('/').pop()?.replace('.yaml', '') || '');
            acc[key] = (yamlModule as any).default;
          } else {
            acc = (yamlModule as any).default; // Directly assign for event configurations
          }
          return acc;
        },
        {} as Record<string, any>
      );

      return configs;
    },
    {} as Record<(typeof supportedLocales)[number], Record<string, any>>
  );
};

/**
 * Load base slide configurations.
 */
export const loadSlideConfigurations = () => {
  return Object.entries(allConfigs).reduce(
    (slideConfigurations, [path, yamlModule]) => {
      if (path.includes('/base/slides/')) {
        const slideConfig = kebabToCamelCase(path.split('/').pop()?.replace('.yaml', '') || '');
        slideConfigurations[slideConfig] = (yamlModule as any).default;
      }
      return slideConfigurations;
    },
    {} as Record<string, any>
  );
};

export const loadLocaleEventConfigurations = () => loadConfigurations('events');

export const loadLocaleSlideConfigurations = () => loadConfigurations('slides');
